import { type HTMLProps, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

const IndeterminateCheckbox = ({
  indeterminate,
  className = '',
  ...rest
}: { indeterminate?: boolean } & HTMLProps<HTMLInputElement>) => {
  const { t } = useTranslation(['common']);
  const ref = useRef<HTMLInputElement>(null!);

  useEffect(() => {
    if (typeof indeterminate === 'boolean') {
      ref.current.indeterminate = !rest.checked && indeterminate;
    }
  }, [ref, indeterminate]);

  const getTitle = (state: 'allSelected' | 'noneSelected' | 'indeterminate') => {
    switch (state) {
      case 'allSelected':
        return t('uncheckAll', { ns: 'common' });
      case 'noneSelected':
      case 'indeterminate':
        return t('checkAll', { ns: 'common' });
      default:
        return t('change', { ns: 'common' });
    }
  };

  return (
    <input
      type="checkbox"
      title={getTitle(
        rest.checked ? 'allSelected' : indeterminate ? 'indeterminate' : 'noneSelected',
      )}
      ref={ref}
      {...rest}
    />
  );
};

export default IndeterminateCheckbox;
